'use client';

import Box from '@mui/material/Box';
import Link from 'next/link';
import { MONO_FONT } from '@/theme';

/**
 * Enlace "ver más" en mono + mayúsculas con flecha. Cierra las secciones-teaser
 * de la home apuntando a su página dedicada.
 *
 * @param {'dark'|'light'} tone  dark → sobre navy · light → sobre crema
 */
export default function MoreLink({ href, children, tone = 'dark', sx = {} }) {
  const color = tone === 'dark' ? 'primary.main' : 'primary.dark';
  return (
    <Box
      component={Link}
      href={href}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px',
        fontFamily: MONO_FONT,
        fontSize: '11px',
        fontWeight: 700,
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color,
        transition: 'gap 0.2s ease',
        '&:hover': { gap: '16px' },
        ...sx,
      }}
    >
      {children}
      <Box component="span" aria-hidden="true">
        →
      </Box>
    </Box>
  );
}
